<template>
  <div>
    <div class="coverShow" v-show="viseable">
      <div class="container-gj" @click.stop>
        <div class="container-gd" @click.stop>
          <div class="header">
            <p>{{ operate == "0" ? "添加题目" : "修改题目" }}</p>
            <i
              class="fa-solid fa-circle-xmark"
              style="color: #8290a3; cursor: pointer"
              @click="handleCloseClick"
            ></i>
          </div>
          <div style="display: flex; align-items: center; margin-top: 15px">
            <el-select
              v-model="libraryName"
              placeholder="请选择"
              style="
                width: 191px;
                background: #f7f7f7;
                border: 1px solid #ededed;
                margin-left: 20px;
              "
              :disabled="operate == '1'"
              @change="handleLibraryChange"
            >
              <el-option
                v-for="item in libraryList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div v-if="operate == '1'" class="type-div">
              {{ getTypeString(dataObj.type) }}
            </div>
          </div>
          <div v-if="operate == '0'" class="type-list">
            <div
              v-for="(item, index) in dataList"
              :key="index"
              :class="[
                typeActive == item.value
                  ? 'type-item-active'
                  : 'type-item-inactive',
              ]"
              @click="handleItemClick(item)"
            >
              {{ item.label }}
            </div>
          </div>
          <div
            v-if="libraryObj && libraryObj.libraryType == '1'"
            class="item-container"
          >
            <div class="item" v-if="typeActive == QuestionType.SCQ">
              <QuestionEditSCQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditSCQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.MCQ">
              <QuestionEditMCQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditMCQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.SBQ">
              <QuestionEditSBQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditSBQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.MBQ">
              <QuestionEditMBQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditMBQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.DLQ">
              <QuestionEditDLQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditDLQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.NPS">
              <QuestionEditNPS
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditNPS>
            </div>
            <div class="item" v-if="typeActive == QuestionType.QA">
              <QuestionEditQA
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditQA>
            </div>
            <div class="item" v-if="typeActive == QuestionType.SRQ">
              <QuestionEditSRQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditSRQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.VOTE">
              <QuestionEditVote
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditVote>
            </div>
            <div class="item" v-if="typeActive == QuestionType.SORT">
              <QuestionEditSort
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditSort>
            </div>
            <div class="item" v-if="typeActive == QuestionType.SCORE">
              <QuestionEditScore
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditScore>
            </div>
            <div class="item" v-if="typeActive == QuestionType.WRQ">
              <QuestionEditWRQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditWRQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.REMARK">
              <QuestionEditRemark
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditRemark>
            </div>
            <div class="item" v-if="typeActive == QuestionType.NAME">
              <QuestionEditName
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditName>
            </div>
            <div class="item" v-if="typeActive == QuestionType.GENDER">
              <QuestionEditGender
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditGender>
            </div>
            <div class="item" v-if="typeActive == QuestionType.AGE">
              <QuestionEditAge
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditAge>
            </div>
            <div class="item" v-if="typeActive == QuestionType.TEL">
              <QuestionEditTel
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditTel>
            </div>
            <div class="item" v-if="typeActive == QuestionType.EMAIL">
              <QuestionEditEmail
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditEmail>
            </div>
            <div class="item" v-if="typeActive == QuestionType.DATE">
              <QuestionEditDate
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditDate>
            </div>
            <div class="item" v-if="typeActive == QuestionType.TIME">
              <QuestionEditTime
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditTime>
            </div>
            <div class="item" v-if="typeActive == QuestionType.ADDR">
              <QuestionEditAddress
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditAddress>
            </div>
            <div class="item" v-if="typeActive == QuestionType.IMAGE">
              <QuestionEditImage
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditImage>
            </div>
            <div class="item" v-if="typeActive == QuestionType.MaxDiff">
              <QuestionEditMaxDiff
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditMaxDiff>
            </div>
            <div class="item" v-if="typeActive == QuestionType.UploadFile">
              <QuestionEditUploadFile
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditUploadFile>
            </div>
            <div class="item" v-if="typeActive == QuestionType.DownloadFile">
              <QuestionEditDownloadFile
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditDownloadFile>
            </div>
            <div class="item" v-if="typeActive == QuestionType.CASCADER">
              <QuestionEditCASCADER
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId + ''"
                @update="updateQuestionClick"
              ></QuestionEditCASCADER>
            </div>
            <div class="item" v-if="typeActive == QuestionType.BDQ">
              <QuestionEditBDQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditBDQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.IDQ">
              <QuestionEditIDQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditIDQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.ELQ">
              <QuestionEditELQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditELQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.WX">
              <QuestionEditWX
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditWX>
            </div>
            <div class="item" v-if="typeActive == QuestionType.Title">
              <QuestionEditTitle
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditTitle>
            </div>
            <div class="item" v-if="typeActive == QuestionType.ImageMCQ">
              <QuestionEditImageMcq
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditImageMcq>
            </div>
            <div class="item" v-if="typeActive == QuestionType.ImageOrVideo">
              <QuestionEditImageOrVideo
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditImageOrVideo>
            </div>
            <div class="item" v-if="typeActive == QuestionType.ImageSCQ">
              <QuestionEditImageScq
                :params="dataObj"
                :index="0"
                :uuid="libraryId"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditImageScq>
            </div>
            <div class="item" v-if="typeActive == QuestionType.MatrixMCQ">
              <QuestionEditMatrixMcq
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditMatrixMcq>
            </div>
            <div class="item" v-if="typeActive == QuestionType.MatrixSCQ">
              <QuestionEditMatrixScq
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditMatrixScq>
            </div>
            <div class="item" v-if="typeActive == QuestionType.PageBreak">
              <QuestionEditPageBreak
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
                :uuid="libraryId"
              ></QuestionEditPageBreak>
            </div>
            <div class="item" v-if="typeActive == QuestionType.Signature">
              <QuestionEditSignature
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
                :uuid="libraryId"
              ></QuestionEditSignature>
            </div>
          </div>
          <div
            v-if="libraryObj && libraryObj.libraryType == '2'"
            class="item-container"
          >
            <div class="item" v-if="typeActive == QuestionType.SCQ">
              <ExamEditSCQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></ExamEditSCQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.MCQ">
              <ExamEditMCQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></ExamEditMCQ>
            </div>

            <div class="item" v-if="typeActive == QuestionType.SBQ">
              <ExamEditSBQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></ExamEditSBQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.MBQ">
              <ExamEditMBQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></ExamEditMBQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.QA">
              <ExamEditQA
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></ExamEditQA>
            </div>
            <div class="item" v-if="typeActive == QuestionType.NAME">
              <QuestionEditName
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditName>
            </div>
            <div class="item" v-if="typeActive == QuestionType.GENDER">
              <QuestionEditGender
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditGender>
            </div>
            <div class="item" v-if="typeActive == QuestionType.AGE">
              <QuestionEditAge
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditAge>
            </div>
            <div class="item" v-if="typeActive == QuestionType.TEL">
              <QuestionEditTel
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditTel>
            </div>
            <div class="item" v-if="typeActive == QuestionType.EMAIL">
              <QuestionEditEmail
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditEmail>
            </div>
            <div class="item" v-if="typeActive == QuestionType.DATE">
              <QuestionEditDate
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditDate>
            </div>
            <div class="item" v-if="typeActive == QuestionType.TIME">
              <QuestionEditTime
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditTime>
            </div>
            <div class="item" v-if="typeActive == QuestionType.ADDR">
              <QuestionEditAddress
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditAddress>
            </div>
            <div class="item" v-if="typeActive == QuestionType.IMAGE">
              <ExamEditIMAGE
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></ExamEditIMAGE>
            </div>
            <div class="item" v-if="typeActive == QuestionType.BDQ">
              <QuestionEditBDQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditBDQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.IDQ">
              <QuestionEditIDQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditIDQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.ELQ">
              <QuestionEditELQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditELQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.WX">
              <QuestionEditWX
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditWX>
            </div>

            <div class="item" v-if="typeActive == QuestionType.TFQ">
              <ExamEditTFQ
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
                :uuid="libraryId"
              ></ExamEditTFQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.ClozeTest">
              <ExamEditClozeTest
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
                :uuid="libraryId"
              ></ExamEditClozeTest>
            </div>
          </div>
          <div
            v-if="libraryObj && libraryObj.libraryType == '3'"
            class="item-container"
          >
            <div class="item" v-if="typeActive == QuestionType.EvaluationSCQ">
              <EvaluationEditSCQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></EvaluationEditSCQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.EvaluationMCQ">
              <EvaluationEditMCQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></EvaluationEditMCQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.EvaluationNPS">
              <EvaluationEditNPS
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></EvaluationEditNPS>
            </div>
            <div class="item" v-if="typeActive == QuestionType.EvaluationScore">
              <EvaluationEditScore
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></EvaluationEditScore>
            </div>
            <div class="item" v-if="typeActive == QuestionType.EvaluationWRQ">
              <EvaluationEditWRQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></EvaluationEditWRQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.TextDescription">
              <EvaluationEditDesc
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></EvaluationEditDesc>
            </div>
            <div class="item" v-if="typeActive == QuestionType.NAME">
              <EvaluationEditName
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></EvaluationEditName>
            </div>
            <div class="item" v-if="typeActive == QuestionType.GENDER">
              <EvaluationEditGender
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></EvaluationEditGender>
            </div>
            <div class="item" v-if="typeActive == QuestionType.AGE">
              <EvaluationEditAge
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></EvaluationEditAge>
            </div>
            <div class="item" v-if="typeActive == QuestionType.ELQ">
              <EvaluationEditELQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></EvaluationEditELQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.DATE">
              <EvaluationEditDate
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></EvaluationEditDate>
            </div>
            <div class="item" v-if="typeActive == QuestionType.ADDR">
              <EvaluationEditAddress
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></EvaluationEditAddress>
            </div>

            <div class="item" v-if="typeActive == QuestionType.Industry">
              <EvaluationEditIndustry
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></EvaluationEditIndustry>
            </div>
            <div class="item" v-if="typeActive == QuestionType.Occupation">
              <EvaluationEditOccupation
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></EvaluationEditOccupation>
            </div>
          </div>
          <div class="confirm-btn" @click="handleConfirmClick">
            {{ operate == "0" ? "确认添加" : "确认修改" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createPCUserLibraryQuestion, userLibraryList } from "@/api/index.js";
import { EditComponents, PreviewComponents } from "@/utils/componentImports.js";

export default {
  components: {
    ...EditComponents,
    ...PreviewComponents,
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: null,
    },
    uuid: {
      type: String,
      default: "",
    },
    operate: {
      type: String,
      default: "0", // 0添加 1编辑
    },
    libraryObj: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      viseable: false,
      loading: null,
      QuestionType: this.$store.getters["questionType/getQuestionType"],
      options: [
        {
          value: "1",
          label: "全部",
        },
        {
          value: "2",
          label: "我的",
        },
        {
          value: "3",
          label: "收藏",
        },
      ],
      value: "",
      wjList: [
        {
          value: "1",
          label: "单选题",
        },
        {
          value: "2",
          label: "多选",
        },
        {
          value: "3",
          label: "填空",
        },
        {
          value: "4",
          label: "多项填空",
        },
        {
          value: "5",
          label: "下拉",
        },
        {
          value: "6",
          label: "NPS",
        },
        {
          value: "7",
          label: "投票",
        },
        {
          value: "8",
          label: "排序",
        },
        {
          value: "9",
          label: "备注",
        },
        {
          value: "10",
          label: "分数评定",
        },
        {
          value: "11",
          label: "问答",
        },
        {
          value: "12",
          label: "权重评分",
        },
        {
          value: "13",
          label: "评星",
        },
        {
          value: "14",
          label: "姓名",
        },
        {
          value: "15",
          label: "性别",
        },
        {
          value: "16",
          label: "年龄",
        },
        {
          value: "17",
          label: "电话号",
        },
        {
          value: "18",
          label: "邮箱",
        },
        {
          value: "19",
          label: "日期",
        },
        {
          value: "20",
          label: "时间",
        },
        {
          value: "21",
          label: "地址",
        },
        {
          value: "23",
          label: "上传图片",
        },
        {
          value: "24",
          label: "MaxDiff",
        },
        {
          value: "25",
          label: "上传文件",
        },
        {
          value: "26",
          label: "下载文件",
        },
        {
          value: "27",
          label: "联级题",
        },
        {
          value: "29",
          label: "出生日期",
          data: {
            type: 29, // 出生日期
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          },
        },
        {
          value: "30",
          label: "身份证号",
        },
        {
          value: "31",
          label: "学历",
        },
        {
          value: "32",
          label: "微信号",
        },
        {
          value: "33",
          label: "标题",
        },
        {
          value: "35",
          label: "矩阵单选",
        },
        {
          value: "36",
          label: "矩阵多选",
        },
        {
          value: "37",
          label: "图片单选",
        },
        {
          value: "38",
          label: "图片多选",
        },
        {
          value: "39",
          label: "图片/视频",
        },
        {
          value: "40",
          label: "签名",
        },
      ],
      ksList: [
        {
          value: "1",
          label: "单选",
        },
        {
          value: "2",
          label: "多选",
        },
        {
          value: "22",
          label: "判断",
        },
        {
          value: "3",
          label: "填空",
        },
        {
          value: "4",
          label: "多项填空",
        },
        {
          value: "11",
          label: "问答",
        },
        {
          value: "23",
          label: "图片上传",
        },
        {
          value: "28",
          label: "完型填空",
        },
        {
          value: "14",
          label: "姓名",
        },
        {
          value: "15",
          label: "性别",
        },
        {
          value: "16",
          label: "年龄",
        },
        {
          value: "17",
          label: "电话号",
        },
        {
          value: "18",
          label: "邮箱",
        },
        {
          value: "19",
          label: "日期",
        },
        {
          value: "20",
          label: "时间",
        },
        {
          value: "21",
          label: "地址",
        },
        {
          value: "29",
          label: "出生日期",
        },
        {
          value: "30",
          label: "身份证号",
        },
        {
          value: "31",
          label: "学历",
        },
        {
          value: "32",
          label: "微信号",
        },
      ],
      cpList: [
        {
          value: "43",
          label: "单选",
        },
        {
          value: "44",
          label: "多选",
        },
        {
          value: "45",
          label: "权重评分",
        },
        {
          value: "46",
          label: "NPS",
        },
        {
          value: "47",
          label: "分数评定",
        },
        {
          value: "48",
          label: "文本描述",
        },
        {
          value: "14",
          label: "姓名",
        },
        {
          value: "15",
          label: "性别",
        },
        {
          value: "16",
          label: "年龄",
        },
        {
          value: "31",
          label: "学历",
        },
        {
          value: "19",
          label: "日期",
        },
        {
          value: "21",
          label: "地址",
        },
        {
          value: "41",
          label: "行业",
        },
        {
          value: "42",
          label: "职业",
        },
      ],
      dataList: [],
      typeActive: 1,
      dataObj: {},
      libraryList: [],
      libraryId: "",
      libraryName: "",
    };
  },
  mounted() {
    this.getLibraryList();
  },
  methods: {
    handleCloseClick() {
      this.$emit("closeDialog");
    },
    handleLibraryChange(val) {
      this.libraryId = val;
      this.libraryName = this.libraryList.find(
        (item) => item.value === val,
      ).label;
      this.libraryObj.libraryType = this.libraryList.find(
        (item) => item.value === val,
      ).type;

      if (this.libraryObj.libraryType == "1") {
        this.dataList = this.wjList;
      } else if (this.libraryObj.libraryType == "2") {
        this.dataList = this.ksList;
      } else {
        this.dataList = this.cpList;
      }
    },
    async handleItemClick(item) {
      console.log("item", item);

      this.typeActive = parseInt(item.value);
      // this.dataObj = JSON.parse(JSON.stringify(item.data));

      if (this.libraryObj.libraryType == "1") {
        const dataItem = await this.$store.dispatch(
          "moduleQuestionnaire/addQuestion",
          this.typeActive,
        );
        this.dataObj = JSON.parse(JSON.stringify(dataItem));
      } else if (this.libraryObj.libraryType == "2") {
        const dataItem = await this.$store.dispatch(
          "moduleExam/addExam",
          this.typeActive,
        );
        this.dataObj = JSON.parse(JSON.stringify(dataItem));
      } else {
        const dataItem = await this.$store.dispatch(
          "moduleEvaluation/addEvaluation",
          this.typeActive,
        );
        this.dataObj = JSON.parse(JSON.stringify(dataItem));
      }
    },
    updateQuestionClick(e) {
      console.log("updateQuestionClick", e);
      this.dataObj = JSON.parse(JSON.stringify(JSON.parse(e).data));
    },
    handleConfirmClick() {
      // console.log("dataObj222222222", this.dataObj, this.uuid);
      var params = {};
      if (this.libraryObj.libraryType == "1") {
        params = this.checkQuestionRequired(this.dataObj);
      } else if (this.libraryObj.libraryType == "2") {
        params = this.checkExamRequired(this.dataObj);
      } else {
        params = this.checkEvaluationRequired(this.dataObj);
      }
      params.libraryId = this.libraryId;
      params.libraryName = this.libraryName;
      params.questionType = "1";
      console.log("e912yryr29ry12r12921t2981ey1298e1298e", params);

      this.$emit("closeDialog");
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      createPCUserLibraryQuestion(params)
        .then((res) => {
          this.loading.close();
          if (res.code == 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.$emit("success", this.libraryId);
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: "error",
          });
        });
    },
    checkQuestionRequired(obj) {
      this.$message.closeAll();
      switch (obj.type) {
        case this.QuestionType.SCQ:
          const list1 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list1.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.MCQ:
          const list2 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list2.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
            minCount: JSON.parse(obj.chooseList).minCount,
            maxCount: JSON.parse(obj.chooseList).maxCount,
          });
          return obj;
        case this.QuestionType.SBQ:
          console.log("obj1111111111111111", obj);
          if (obj.caseProblem == "") {
            this.$message({
              type: "error",
              message: "题目不能为空",
              offset: "150",
            });
            return;
          } else if (!obj.caseProblem.includes("____")) {
            this.$message({
              type: "error",
              message: "请插入填空符",
              offset: "150",
            });
            return;
          }
          return obj;
        case this.QuestionType.MBQ:
          const list3 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请填写以下内容" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list3.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? "请输入" : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.DLQ:
          const list4 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list4.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.NPS:
          obj.caseProblem =
            obj.caseProblem === ""
              ? "您向朋友或同事推荐我们的可能性有多大"
              : obj.caseProblem;
          return obj;
        case this.QuestionType.VOTE:
          const list5 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list5.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.SORT:
          const list6 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请给以下选项排序" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list6.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.REMARK:
          obj.caseProblem =
            obj.caseProblem === ""
              ? "请阅读本项说明，然后回答问题"
              : obj.caseProblem;
          return obj;
        case this.QuestionType.SCORE:
          const list7 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list7.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.QA:
          obj.caseProblem =
            obj.caseProblem === "" ? "请填写问答题目" : obj.caseProblem;
          return obj;
        case this.QuestionType.WRQ:
          const list8 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请给本项打分" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list8.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `打分项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.SRQ:
          const list9 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请给本项打分" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list9.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `打分项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.NAME:
          obj.caseProblem = obj.caseProblem === "" ? "姓名" : obj.caseProblem;
          return obj;
        case this.QuestionType.GENDER:
          const list10 = JSON.parse(obj.chooseList).list;
          obj.caseProblem = obj.caseProblem === "" ? "性别" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list10.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.AGE:
          const list11 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "您的年龄是" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list11.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.TEL:
          obj.caseProblem = obj.caseProblem === "" ? "手机号" : obj.caseProblem;
          return obj;
        case this.QuestionType.EMAIL:
          obj.caseProblem = obj.caseProblem === "" ? "邮箱" : obj.caseProblem;
          return obj;
        case this.QuestionType.DATE:
          obj.caseProblem = obj.caseProblem === "" ? "日期" : obj.caseProblem;
          return obj;
        case this.QuestionType.TIME:
          obj.caseProblem = obj.caseProblem === "" ? "时间" : obj.caseProblem;
          return obj;
        case this.QuestionType.ADDR:
          obj.caseProblem = obj.caseProblem === "" ? "地址" : obj.caseProblem;
          return obj;
        case this.QuestionType.IMAGE:
          obj.caseProblem =
            obj.caseProblem === "" ? "上传图片回答问题" : obj.caseProblem;
          return obj;
        case this.QuestionType.MaxDiff:
          obj.caseProblem =
            obj.caseProblem === "" ? "请输入题目" : obj.caseProblem;
          return obj;
        case this.QuestionType.UploadFile:
          obj.caseProblem =
            obj.caseProblem === "" ? "请上传文件" : obj.caseProblem;
          return obj;
        case this.QuestionType.DownloadFile:
          obj.caseProblem =
            obj.caseProblem === "" ? "请输入题目说明" : obj.caseProblem;
          return obj;
        case this.QuestionType.CASCADER:
          obj.caseProblem =
            obj.caseProblem === "" ? "请输入题目说明" : obj.caseProblem;
          return obj;
        case this.QuestionType.BDQ:
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择出生日期" : obj.caseProblem;
          return obj;
        case this.QuestionType.IDQ:
          obj.caseProblem =
            obj.caseProblem === "" ? "请输入身份证号" : obj.caseProblem;
          return obj;
        case this.QuestionType.ELQ:
          obj.caseProblem =
            obj.caseProblem === ""
              ? "您的最高学历() 包括在读是？"
              : obj.caseProblem;
          return obj;
        case this.QuestionType.WX:
          obj.caseProblem =
            obj.caseProblem === "" ? "请填写微信号" : obj.caseProblem;
          return obj;
        case this.QuestionType.MatrixSCQ:
        case this.QuestionType.MatrixMCQ:
          const percentageTitles = ["满意", "不满意", "中立"];
          return {
            ...obj,
            caseProblem:
              obj.caseProblem.trim() === "" ? "请输入标题" : obj.caseProblem,
            chooseList: JSON.stringify({
              list: JSON.parse(obj.chooseList).list.map((temp, idx) => {
                return {
                  ...temp,
                  context:
                    temp.context === "" ? "标题" + (idx + 1) : temp.context,
                };
              }),
              verticalNum: JSON.parse(obj.chooseList).percentageTitle.split(",")
                .length,
              percentageTitle: JSON.parse(obj.chooseList)
                .percentageTitle.split(",")
                .map((title, titIdx) => {
                  return title.trim() === "" ? percentageTitles[titIdx] : title;
                })
                .slice(0, parseInt(JSON.parse(obj.chooseList).verticalNum))
                .join(","), //竖列标题
              horizontalTitle:
                JSON.parse(obj.chooseList).horizontalTitle === ""
                  ? "横标题"
                  : JSON.parse(obj.chooseList).horizontalTitle,
            }),
          };
        case this.QuestionType.ImageSCQ:
          const imageScqEmpty = JSON.parse(obj.chooseList).list.some(
            (temp) => temp.img_path === "",
          );
          if (imageScqEmpty) {
            this.$message.error("请上传图片");
            return null;
          }
          return {
            ...obj,
            caseProblem:
              obj.caseProblem.trim() === "" ? "请选择" : obj.caseProblem,
            chooseList: JSON.stringify({
              list: JSON.parse(obj.chooseList).list.map((temp, idx) => {
                return {
                  ...temp,
                  text: temp.text === "" ? "选项" + (idx + 1) : temp.text,
                  context:
                    temp.context === "" ? "说明（限制24字）" : temp.context,
                };
              }),
            }),
          };
        case this.QuestionType.ImageMCQ:
          const imageMcqEmpty = JSON.parse(obj.chooseList).list.some(
            (temp) => temp.img_path === "",
          );
          if (imageMcqEmpty) {
            this.$message.error("请上传图片");
            return null;
          }
          return {
            ...obj,
            caseProblem:
              obj.caseProblem.trim() === "" ? "请选择" : obj.caseProblem,
            chooseList: JSON.stringify({
              list: JSON.parse(obj.chooseList).list.map((temp, idx) => {
                return {
                  ...temp,
                  text: temp.text === "" ? "选项" + (idx + 1) : temp.text,
                  context:
                    temp.context === "" ? "说明（限制24字）" : temp.context,
                };
              }),
              maxCount: JSON.parse(obj.chooseList).maxCount,
              minCount: JSON.parse(obj.chooseList).minCount,
              isCountMust: JSON.parse(obj.chooseList).isCountMust,
              isCountSwitch: JSON.parse(obj.chooseList).isCountSwitch,
            }),
          };
        case this.QuestionType.Signature:
          return {
            ...obj,
            caseProblem:
              obj.caseProblem.trim() === ""
                ? "请输入题目标题"
                : obj.caseProblem,
          };
        case this.QuestionType.ImageOrVideo:
          const isEmpty = JSON.parse(obj.chooseList).list.some(
            (temp) => temp.url === "",
          );
          if (isEmpty) {
            this.$message.error("请上传图片");
            return null;
          }
          return {
            ...obj,
            caseProblem:
              obj.caseProblem.trim() === ""
                ? "请上传图片或视频回答问题"
                : obj.caseProblem,
          };
        case this.QuestionType.TITLE:
          return {
            ...obj,
            caseProblem:
              obj.caseProblem.trim() === "" ? "（一）标题" : obj.caseProblem,
          };
        default:
          break;
      }
    },
    checkExamRequired(obj) {
      switch (obj.type) {
        case this.QuestionType.SCQ:
          const list1 = JSON.parse(obj.chooseList).list;
          if (!list1.some((item) => item.isCorrect)) {
            this.$message({
              type: "error",
              message: "请设置正确答案",
              offset: "150",
            });
            return;
          }
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list1.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.MCQ:
          const list2 = JSON.parse(obj.chooseList).list;
          if (!list2.some((item) => item.isCorrect)) {
            this.$message({
              type: "error",
              message: "请设置正确答案",
              offset: "150",
            });
            return;
          }
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list2.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
            minCount: JSON.parse(obj.chooseList).minCount,
            maxCount: JSON.parse(obj.chooseList).maxCount,
          });
          return obj;
        case this.QuestionType.TFQ:
          const list3 = JSON.parse(obj.chooseList).list;
          if (!list3.some((item) => item.isCorrect)) {
            this.$message({
              type: "error",
              message: "请设置正确答案",
              offset: "150",
            });
            return;
          }
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list2.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
            minCount: JSON.parse(obj.chooseList).minCount,
            maxCount: JSON.parse(obj.chooseList).maxCount,
          });
          return obj;

        case this.QuestionType.SBQ:
          console.log("obj1111111111111111", obj);
          if (obj.caseProblem == "") {
            this.$message({
              type: "error",
              message: "题目不能为空",
              offset: "150",
            });
            return;
          } else if (!obj.caseProblem.includes("____")) {
            this.$message({
              type: "error",
              message: "请插入填空符",
              offset: "150",
            });
            return;
          }
          if (
            obj.chooseAnswer.split(";").length <
            obj.caseProblem.split("____").length - 1
          ) {
            this.$message.error("请输入答案");
            return null;
          }
          const isCorrect4 = item.chooseAnswer
            .split(";")
            .some((obj) => obj.trim() === "");
          if (isCorrect4) {
            this.$message.error("请输入答案");
            return null;
          }
          return obj;
        case this.QuestionType.MBQ:
          const list5 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请填写以下内容" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list5.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? "请输入" : item.text;
              return item;
            }),
          });
          const isCorrect5 = JSON.parse(obj.chooseList).list.some(
            (item) => item.correct_answer.trim() === "",
          );
          if (isCorrect5) {
            this.$message.error("请输入答案");
            return null;
          }
          return obj;
        case this.QuestionType.QA:
          if (obj.scoringMethod === 0) {
            if (obj.chooseAnswer.trim() === "") {
              this.$message.error("请输入答案");
              return null;
            }
          } else {
            if (obj.keyword.trim() === "") {
              this.$message.error("请输入关键字");
              return null;
            }
          }
          obj.caseProblem =
            obj.caseProblem === "" ? "请填写问答题目" : obj.caseProblem;
          return obj;
        case this.QuestionType.IMAGE:
          obj.caseProblem =
            obj.caseProblem === "" ? "上传图片回答问题" : obj.caseProblem;
          return obj;

        case this.QuestionType.ClozeTest:
          if (obj.caseProblem.includes(" ") && obj.caseProblem.trim() === "") {
            this.$message.error("请输入题目");
            return null;
          }
          const isCorrect6 = JSON.parse(obj.chooseList).list.every((item) => {
            return item.title.some((titleItem) => titleItem.isCorrect === true);
          });
          if (!isCorrect6) {
            this.$message.error("请设置正确答案");
            return null;
          }
          return {
            ...obj,
            caseProblem:
              obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem,
            chooseList: JSON.stringify({
              list: JSON.parse(obj.chooseList).list.map((temp, idx) => {
                const newTitle = temp.title.map((titleItem, titleIdx) => {
                  return {
                    ...titleItem,
                    text:
                      titleItem.text === ""
                        ? `选项${titleIdx + 1}`
                        : titleItem.text,
                  };
                });
                return {
                  ...temp,
                  title: newTitle,
                };
              }),
              count: JSON.parse(item.chooseList).count,
            }),
          };
        case this.QuestionType.NAME:
          obj.caseProblem = obj.caseProblem === "" ? "姓名" : obj.caseProblem;
          return obj;
        case this.QuestionType.GENDER:
          const list10 = JSON.parse(obj.chooseList).list;
          obj.caseProblem = obj.caseProblem === "" ? "性别" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list10.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.AGE:
          const list11 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "您的年龄是" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list11.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.TEL:
          obj.caseProblem = obj.caseProblem === "" ? "手机号" : obj.caseProblem;
          return obj;
        case this.QuestionType.EMAIL:
          obj.caseProblem = obj.caseProblem === "" ? "邮箱" : obj.caseProblem;
          return obj;
        case this.QuestionType.DATE:
          obj.caseProblem = obj.caseProblem === "" ? "日期" : obj.caseProblem;
          return obj;
        case this.QuestionType.TIME:
          obj.caseProblem = obj.caseProblem === "" ? "时间" : obj.caseProblem;
          return obj;
        case this.QuestionType.ADDR:
          obj.caseProblem = obj.caseProblem === "" ? "地址" : obj.caseProblem;
          return obj;
        case this.QuestionType.BDQ:
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择出生日期" : obj.caseProblem;
          return obj;
        case this.QuestionType.IDQ:
          obj.caseProblem =
            obj.caseProblem === "" ? "请输入身份证号" : obj.caseProblem;
          return obj;
        case this.QuestionType.ELQ:
          obj.caseProblem =
            obj.caseProblem === ""
              ? "您的最高学历() 包括在读是？"
              : obj.caseProblem;
          return obj;
        case this.QuestionType.WX:
          obj.caseProblem =
            obj.caseProblem === "" ? "请填写微信号" : obj.caseProblem;
          return obj;
        default:
          break;
      }
    },
    checkEvaluationRequired(obj) {
      switch (obj.type) {
        case this.QuestionType.EvaluationSCQ:
          const list1 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list1.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.EvaluationMCQ:
          const list2 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list2.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
            minCount: JSON.parse(obj.chooseList).minCount,
            maxCount: JSON.parse(obj.chooseList).maxCount,
          });
          return obj;
        case this.QuestionType.EvaluationNPS:
          obj.caseProblem =
            obj.caseProblem === ""
              ? "您向朋友或同事推荐我们的可能性有多大"
              : obj.caseProblem;
          return obj;
        case this.QuestionType.EvaluationWRQ:
          const list8 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请给本项打分" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list8.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `打分项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.EvaluationScore:
          const list7 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请给本项打分" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list7.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.TextDescription:
          obj.caseProblem =
            obj.caseProblem === "" ? "请填写问答题目" : obj.caseProblem;
          return obj;
        case this.QuestionType.NAME:
          obj.caseProblem = obj.caseProblem === "" ? "姓名" : obj.caseProblem;
          return obj;
        case this.QuestionType.GENDER:
          const list10 = JSON.parse(obj.chooseList).list;
          obj.caseProblem = obj.caseProblem === "" ? "性别" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list10.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.AGE:
          const list11 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "您的年龄是" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list11.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.ELQ:
          obj.caseProblem =
            obj.caseProblem === ""
              ? "您的最高学历() 包括在读是？"
              : obj.caseProblem;
          return obj;
        case this.QuestionType.DATE:
          obj.caseProblem = obj.caseProblem === "" ? "日期" : obj.caseProblem;
          return obj;
        case this.QuestionType.ADDR:
          obj.caseProblem = obj.caseProblem === "" ? "地址" : obj.caseProblem;
          return obj;
        case this.QuestionType.Industry:
          obj.caseProblem = obj.caseProblem === "" ? "行业" : obj.caseProblem;
          return obj;
        case this.QuestionType.Occupation:
          obj.caseProblem = obj.caseProblem === "" ? "职业" : obj.caseProblem;
          return obj;
        default:
          break;
      }
    },
    getLibraryList() {
      userLibraryList({
        // libraryType: this.libraryObj.libraryType,
        libraryType: "",
      })
        .then((res) => {
          console.log("==============1", res);
          if (res.code === 200) {
            console.log("【】【】【】wewqepqwpeqw", this.uuid);

            this.libraryList = res.data.map((item) => {
              return {
                label: item.libraryName,
                value: item.id,
                type: item.libraryType,
              };
            });
            if (this.uuid != "") {
              for (let i = 0; i < this.libraryList.length; i++) {
                const element = this.libraryList[i];
                if (element.value == this.uuid) {
                  this.libraryId = element.value;
                  this.libraryName = element.label;
                  this.libraryType = element.type;
                }
              }
            } else {
              this.libraryId = res.data[0].id;
              this.libraryName = res.data[0].libraryName;
            }
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
          console.log("i912u9ry18r2189r21yr981", this.libraryId);
        })
        .catch((err) => {});
    },
    getTypeString(type) {
      switch (type) {
        case this.QuestionType.SCQ:
          return "单选";
        case this.QuestionType.MCQ:
          return "多选";
        case this.QuestionType.SBQ:
          return "填空";
        case this.QuestionType.MBQ:
          return "多项填空";
        case this.QuestionType.DLQ:
          return "下拉";
        case this.QuestionType.NPS:
          return "NPS";
        case this.QuestionType.VOTE:
          return "投票";
        case this.QuestionType.SORT:
          return "排序";
        case this.QuestionType.REMARK:
          return "备注";
        case this.QuestionType.SCORE:
          return "分数评定";
        case this.QuestionType.QA:
          return "问答";
        case this.QuestionType.WRQ:
          return "权重评分";
        case this.QuestionType.SRQ:
          return "评星";
        case this.QuestionType.NAME:
          return "姓名";
        case this.QuestionType.GENDER:
          return "性别";
        case this.QuestionType.AGE:
          return "年龄";
        case this.QuestionType.TEL:
          return "电话号";
        case this.QuestionType.EMAIL:
          return "邮箱";
        case this.QuestionType.DATE:
          return "日期";
        case this.QuestionType.TIME:
          return "时间";
        case this.QuestionType.ADDR:
          return "地址";
        case this.QuestionType.TFQ:
          return "判断题";
        case this.QuestionType.IMAGE:
          return "图片";
        case this.QuestionType.MaxDiff:
          return "MaxDiff题";
        case this.QuestionType.UploadFile:
          return "上传文件";
        case this.QuestionType.DownloadFile:
          return "下载文件";
        case this.QuestionType.CASCADER:
          return "联级题";
        case this.QuestionType.BDQ:
          return "出生日期";
        case this.QuestionType.IDQ:
          return "身份证号";
        case this.QuestionType.ELQ:
          return "学历";
        case this.QuestionType.WX:
          return "微信号";
        case this.QuestionType.MatrixScq:
          return "矩阵单选";
        case this.QuestionType.MatrixMcq:
          return "矩阵多选";
      }
    },
  },
  watch: {
    async showDialog(newVal) {
      this.viseable = newVal;
      console.log("this.libraryObj99999999", this.libraryObj);
      if (this.libraryObj.libraryType == "1") {
        this.dataList = this.wjList;
      } else if (this.libraryObj.libraryType == "2") {
        this.dataList = this.ksList;
      } else {
        this.dataList = this.cpList;
      }
      console.log(
        "this.dataObj0000000000000",
        this.libraryObj.libraryType,
        this.dataList,
        this.cpList,
      );

      if (this.params != null) {
        console.log("defwef9192y2r12r012ry12r1", this.params);

        this.dataObj = this.params;
        this.typeActive = this.dataObj.type;
      } else {
        this.typeActive = parseInt(this.dataList[0].value);
        if (this.libraryObj.libraryType == "1") {
          const dataItem = await this.$store.dispatch(
            "moduleQuestionnaire/addQuestion",
            this.typeActive,
          );
          this.dataObj = JSON.parse(JSON.stringify(dataItem));
        } else if (this.libraryObj.libraryType == "2") {
          const dataItem = await this.$store.dispatch(
            "moduleExam/addExam",
            this.typeActive,
          );
          this.dataObj = JSON.parse(JSON.stringify(dataItem));
        } else {
          const dataItem = await this.$store.dispatch(
            "moduleEvaluation/addEvaluation",
            this.typeActive,
          );
          this.dataObj = JSON.parse(JSON.stringify(dataItem));
        }
        // this.dataObj = JSON.parse(JSON.stringify(this.dataList[0].data));
      }

      this.getLibraryList();
    },
    uuid: {
      handler(newVal, oldVal) {
        this.libraryId = newVal;
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.flexs {
  display: flex;
}

.paddings {
  padding: 0;
}

.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  z-index: 99;
  transform: translate(-50%, -50%);
}

.container-gd {
  /* padding: 17px 28px; */
  position: fixed;
  top: 50%;
  left: 50%;
  width: 780px;
  /* height: 600px; */
  background: #ffffff;
  z-index: 99;
  transform: translate(-50%, -50%);
  overflow: hidden;
  border-radius: 10px;
}

.container-gd::-webkit-scrollbar {
  display: none;
}

.header {
  width: 100%;
  height: 55px;
  border-bottom: 1px solid #e7e7e7;
  position: relative;

  p {
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  i {
    font-size: 20px;
    font-weight: 500;
    color: #333333;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
  }
}

.type-list {
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
}

.type-item-active {
  padding: 5px 13px;
  line-height: 20px;
  background: #1877ff;
  border: 1px solid #1877ff;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: Medium;
  text-align: center;
  color: #ffffff;
  margin-right: 10px;
  margin-top: 10px;
  cursor: pointer;
}

.type-item-inactive {
  padding: 5px 13px;
  line-height: 20px;
  border: 1px solid #1877ff;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: Medium;
  text-align: center;
  color: #1877ff;
  margin-right: 10px;
  margin-top: 10px;
  cursor: pointer;
}

.item-container {
  padding: 0 20px;
  margin-top: 10px;
  box-sizing: border-box;
  height: 480px;
  overflow: hidden;
  overflow-y: auto;
}

.confirm-btn {
  width: 89px;
  height: 38px;
  background: #1877ff;
  border: 1px solid #1877ff;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: Medium;
  text-align: center;
  color: #ffffff;
  line-height: 38px;
  cursor: pointer;
  margin: 10px auto;
}

.type-div {
  width: 68px;
  height: 38px;
  background: #1877ff;
  border: 1px solid #1877ff;
  border-radius: 4px;
  margin-left: 10px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: Medium;
  text-align: center;
  color: #ffffff;
  line-height: 38px;
}
</style>



// WEBPACK FOOTER //
// src/components/LibraryEditDialog/index.vue